export { typeUtils as utils } from 'glass-easel';
export var StyleIsolation;
(function (StyleIsolation) {
    StyleIsolation["Isolated"] = "isolated";
    StyleIsolation["ApplyShared"] = "apply-shared";
    StyleIsolation["Shared"] = "shared";
    StyleIsolation["PageIsolated"] = "page-isolated";
    StyleIsolation["PageApplyShared"] = "page-apply-shared";
    StyleIsolation["PageShared"] = "page-shared";
})(StyleIsolation || (StyleIsolation = {}));
//# sourceMappingURL=types.js.map